import React, { Component } from 'react'

// import WizardStep from './WizardStep'
// import WizardSwitch from './WizardSwitch'
// import WizardGoto from './WizardGoto'

// TODO: onAbort (Caso de erro, abortar imediatamente ou prover tratativa)


const WIZARD_PREVIOUS_STEP = -1
const WIZARD_NEXT_STEP = 1

class Wizard extends Component {

  constructor(props) {
    super(props)

    const { onBeforeFirstStep, onPreviousStep, onAfterLastStep, onNextStep } = props
    
    this.state = {
      ...this.getInitialState(),
      onBeforeFirstStep: onBeforeFirstStep || onPreviousStep || (() => {}),
      onAfterLastStep: onAfterLastStep || onNextStep || (() => {}),
    }
  }

  getInitialState() {
    return {
      currentStep: 0,
    }
  }

  isBeforeFirstStep() {
    return this.state.currentStep < 0
  }

  isAfterLastStep() {
    return this.state.currentStep >= this.props.children.length
  }

  isCurrentStepOutOfRange() {
    return this.isBeforeFirstStep() || this.isAfterLastStep()
  }

  getStep(direction) {
    return this.state.currentStep + 1 * direction
  }

  onPreviousStep = () => {
    const previousStep = this.getStep(WIZARD_PREVIOUS_STEP)

    this.setState({ currentStep: previousStep }, () => {
      this.isBeforeFirstStep() && this.state.onBeforeFirstStep()
    })
  }

  onNextStep = () => {
    const nextStep = this.getStep(WIZARD_NEXT_STEP)

    this.setState({ currentStep: nextStep }, () => {
      this.isAfterLastStep() && this.state.onAfterLastStep()
    })
  }

  onReset = () => {
    this.setState(this.getInitialState())
    this.props.onReset()
  }

  render() {
    const { currentStep } = this.state

    if (this.isCurrentStepOutOfRange()) return null

    return React.Children.map(this.props.children, (child, i) => {

      if (i !== currentStep) return null

      return React.cloneElement(child, {
        isCurrentStep: true,
        onPreviousStep: () => this.onPreviousStep(),
        onNextStep: () => this.onNextStep(),
        onReset: () => this.onReset(),
      })
    })
  }
}

export default Wizard


// WEBPACK FOOTER //
// ./src/components/Wizard/index.js